var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';
import { cn } from '@costar-ui/cosmos';
export const IconPrivate = React.forwardRef(function IconPrivate(props, ref) {
  const {
    className,
    attr,
    color = 'currentColor',
    title,
    size = '1.5em',
    children
  } = props,
        rest = __rest(props, ["className", "attr", "color", "title", "size", "children"]);

  return React.createElement("svg", Object.assign({
    ref: ref
  }, attr, {
    className: cn('csg-ui-icon-svg', className),
    fill: color,
    height: size,
    width: size
  }, rest), title && React.createElement("title", null, title), children);
});

function Tree2Element(tree) {
  return tree && tree.map((node, i) => React.createElement(node.tag, Object.assign({
    key: i
  }, node.attr), Tree2Element(node.child)));
}

export function GenIcon(data) {
  return function Icon(props) {
    const {
      attr
    } = data !== null && data !== void 0 ? data : {};
    return React.createElement(IconPrivate, Object.assign({
      attr: attr
    }, props), Tree2Element(data.child));
  };
}